import React, { Component } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { price } from "../../../lib/utils";

/**
 * TotalRow
 */
class TotalRow extends Component {
  static propTypes = {
    forceOtherCosts: PropTypes.bool,
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Immutable.List)]).isRequired,
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    forceOtherCosts: false
  };

  isDisplayingTotal() {
    const { id, value, forceOtherCosts } = this.props;
    if (!value && id.indexOf("otherCosts") === 0 && forceOtherCosts) {
      return true;
    }
    if (id.indexOf("otherCosts") === 0 && !forceOtherCosts) {
      return false;
    }
    if (
      !value ||
      (id === "discounts" && value.size === 0) ||
      (id === "totalEx" && !__DEV__) ||
      (id === "productCosts" && !__DEV__)
    ) {
      return false;
    }
    return true;
  }

  renderTitle() {
    const { id, value, t } = this.props;
    if (id === "totalEx" || id === "productCosts") {
      return (
        <i>
          {t(id)} (<abbr title="NON PRODUCTION ENVIRONMENT">NPE</abbr> ONLY)
        </i>
      );
    }
    if (id === "otherCostsType") {
      switch (value) {
        case 1:
          return t("otherCostsRibbon");
        case 0:
          return t("otherCostsBoth");
        case -1:
          return t("otherCostsCard");
      }
    }
    return t(id);
  }

  render() {
    const { id, value } = this.props;
    if (!this.isDisplayingTotal()) {
      return null;
    }
    const classes = ["Cart__Overview__TotalRow"];
    if (id === "totalIn") {
      classes.push("Cart__Overview__TotalRow--bold");
    }
    if (id === "shippingCosts" || id === "totalIn") {
      classes.push("Cart__Overview__TotalRow--separator");
    }
    return (
      <div className={classes.join(" ")}>
        <div className="Cart__Overview__TotalRow__Title ">{this.renderTitle()}</div>
        <div className="Cart__Overview__TotalRow__Price ">{price(value)}</div>
      </div>
    );
  }
}

export default TotalRow;
